import React from "react";
import {
  Col,
  Row,
} from "reactstrap";
import Widget from "../../components/Widget/Widget";

const Orders = () => {
  return (
    <div>
      <Row>
        <Col className="mb-4" xs={12}>
          <Widget className="widget-p-lg">
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
              <div className="text-center">
                <h3 className="headline-2 mb-3">Orders Management</h3>
                <p className="body-2 text-muted">Coming soon - Manage your hotel supply orders here</p>
              </div>
            </div>
          </Widget>
        </Col>
      </Row>
    </div>
  )
}

export default Orders;